import type { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import type { Observable } from "rxjs";

export function uiTimezoneInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const timeZone = ((): string => {
    try {
      const tz = Intl?.DateTimeFormat?.().resolvedOptions().timeZone;
      return tz ?? null;
    } catch {
      return null;
    }
  })();

  if(!timeZone) {
    return next(req);
  }

  req = req.clone({
    setHeaders: {
      "X-Timezone": timeZone,
    },
  });
  return next(req);
}
